function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "uptriangle-a",
  points: "0 0 6 0 6 4 0 4"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "uptriangle-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#uptriangle-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4.9961,4 L1.0051,4 C0.1661,4 -0.3029,3.031 0.2191,2.374 L2.3491,0.24 C2.7241,-0.08 3.2761,-0.08 3.6511,0.24 L5.7811,2.376 C6.3021,3.032 5.8341,4 4.9961,4",
  mask: "url(#uptriangle-b)"
}));

var SvgUpTriangle = function SvgUpTriangle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 7,
      height: 7,
      viewBox: "0 0 7 7"
    }, props), _ref, _ref2)
  );
};

export default SvgUpTriangle;